import React from "react";
import { Animated } from "react-animated-css";
import { connect } from "react-redux";
import Sedan from "../../assets/img/sedan";
import Truck from "../../assets/img/truck";
import TruckHeavy from "../../assets/img/truck-heavy";
import TruckL from "../../assets/img/truckl";
import TruckXl from "../../assets/img/truckXl";
import TruckXl2 from "../../assets/img/truckxl2";
import TruckXxl from "../../assets/img/truckXxl";
import Bike from "../../assets/img/bike";
import Allvehicle from "../../assets/img/all";
import socket from "../../assets/socketConnection";
import {
  fetchSuggestionPriceAsync,
  setSelectedVehicle,
} from "../../redux/newRequest/newRequest.actions";
import { fetchCheckTypeOfLoadReqAsync } from "../../redux/preReq/preReq.actions";
import { CarSingleStyled } from "./carSingle.styles";
import { socketServer } from "../../assets/socketConnection";
const CarSingle = ({
  info,
  active,
  setSelectedVehicle,
  fetchSuggestionPriceAsync,
  fetchCheckTypeOfLoadReqAsync,

  second,
}) => {
  // console.log(info)

  const handle_carSingle_click = (info) => () => {
    setSelectedVehicle(info);
    fetchSuggestionPriceAsync(socket);
    fetchCheckTypeOfLoadReqAsync(socket);
  };

  const chooseImg = (img) => () => {
    if (img === "bic_png.png") return <Bike />;
    if (img === "sedan.png") return <Sedan />;
    if (img === "truck.png") return <Truck />;
    if (img === "truck_heavy.png") return <TruckHeavy />;
    if (img === "truckl.png") return <TruckL />;
    if (img === "truckxl.png") return <TruckXl />;
    if (img === "truckxl2.png") return <TruckXl2 />;
    if (img === "truckxxl.png") return <TruckXxl />;
    if (img === "alltruck.png") return <Allvehicle />;
  };

  const { v_name, img,max_weight_persian } = info;
  console.log(info);
  // let a=img?require(`${socketServer}images/${img}`):require('../../assets/img/sedan')
  //   debugger;
  return (
    <CarSingleStyled
      onClick={handle_carSingle_click(info)}
      active={active}
      second
    >
      <div className="font-weight-bold">{v_name} ({max_weight_persian})</div>

      <Animated
        animationIn="bounceInRight"
        animationOut="bounceOutRight"
        animationInDuration={1000}
        animationOutDuration={2500}
        isVisible={!active}
        className="animated position-relative"
      >
        <div className="car-single__img">{chooseImg(img)()}</div>
      </Animated>
    </CarSingleStyled>
  );
};

const mapStateToProps = null;

const mapDispatchToProps = (dispatch) => ({
  setSelectedVehicle: (x) => dispatch(setSelectedVehicle(x)),
  fetchCheckTypeOfLoadReqAsync: (x) =>
    dispatch(fetchCheckTypeOfLoadReqAsync(x)),
  fetchSuggestionPriceAsync: (x) => dispatch(fetchSuggestionPriceAsync(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CarSingle);
